import "../../style.css";
import { useState, useEffect, useCallback } from "react";
import { Col, Form, Row } from "react-bootstrap";
import ButtonCom from "../../../../components/button/button";
import { Link, useNavigate } from "react-router-dom";
import { HiArrowLongRight } from "react-icons/hi2";
import { TiDeleteOutline } from "react-icons/ti";
import { GoVideo } from "react-icons/go";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import { MdClear } from 'react-icons/md';
import PayrollCard from "../../../../components/PayrollCard/PayrollCard";
import Widgets from "../../../../components/Widgets/index";
import {
  fetchBranchData,
  initBranchState,
} from "../../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../../redux/slices/departmentSlice";
import {
  fetchData,
  initShiftState,
} from "../../../../redux/slices/shiftsSlice";
import {
  commonSaveData,
  initCommonState,
} from "../../../../redux/slices/commonSlice";
import { calculateEarnedSalaryPath } from "../../../../services/config";

import { useDispatch, useSelector } from "react-redux";

import { HasPermission } from "../../../../services/hasPermission";
import { toast } from "react-toastify";

const PayrollSummary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const commonStore = useSelector((state) => state.common);

  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [maxMonth, setMaxMonth] = useState("");
  const [summary, setSummary] = useState({});
  const [totalFinalized, setTotalFinalized] = useState(0);

  const [state, setState] = useState({
    payrollMonth: "",
    branchId: "",
    shiftId: "",
    departmentId: "",
  });

  const submitDataForSummary = useCallback((date, branchId, shiftId, departmentId) => {
    if (date) {
      const data = {
        path: calculateEarnedSalaryPath,
        data: {
          userId: user.user_id,
          selectedDate: `${date}-01`,
          branchId: branchId,
          shiftId: shiftId,
          departmentId: departmentId,
        },
      };
      dispatch(commonSaveData(data));
    }
  }, []);

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      payrollMonth: `${year}-${month}`,
    }));
    submitDataForSummary(
      `${year}-${month}`,
      state.branchId,
      state.shiftId,
      state.departmentId
    );
  }, []);

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }
  }, [
    branchState.brnGetSuccess,
    departState.depGetSuccess,
    shiftState.shiftGetSuccess,
  ]);

  const handelChange = ({ target: { name, value } }) => {
    setState((pre) => ({
      ...pre,
      [name]: value,
    }));

    if (name == "payrollMonth") {
      submitDataForSummary(
        value,
        state.branchId,
        state.shiftId,
        state.departmentId
      );
      return;
    }

    if (name == "branchId") {
      submitDataForSummary(
        state.payrollMonth,
        value,
        state.shiftId,
        state.departmentId
      );
      return;
    }

    if (name == "shiftId") {
      submitDataForSummary(
        state.payrollMonth,
        state.branchId,
        value,
        state.departmentId
      );
      return;
    }

    if (name == "departmentId") {
      submitDataForSummary(
        state.payrollMonth,
        state.branchId,
        state.shiftId,
        value
      );
      return;
    }
  };

  useEffect(() => {
    if (commonStore.commonSuccess) {
      setSummary(commonStore.commonData);

      let count = 0;
      commonStore.commonData.staffDetails?.map((item) => {
        if (item.salaryCountDays.length === 0) {
          // console.log("its an array");
        } else {
          count++;
        }
      });

      setTotalFinalized(count);
      dispatch(initCommonState());
    }
    if (commonStore.commonError) {
      toast.error(commonStore.commonMessage)
      dispatch(initCommonState());
    }

  }, [commonStore]);

  const handleAddCtc = () => {
    navigate(`#run-payroll`);
  };

const navigateIt = () => {
  window.location.href = "/payroll";
  sessionStorage.setItem("payrollTab", "run-payroll");
};

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");

  const clearFilter = () => {
    setState((pre) => ({
      ...pre,
      payrollMonth: `${year_1}-${month_1}`,
      branchId: "",
      shiftId: "",
      departmentId: "",
    }))
    submitDataForSummary(state.payrollMonth, state.branchId, state.shiftId, state.departId);
  }

  // HTML ELEMENT RENDERING ---------------------------------------------------
  return (
    <div className="mt-2">
      <Widgets
        body={
          <div className="px-1">
            <div
              style={{ marginTop: "-20px" }}
              className="d-flex align-items-center justify-content-between"
            >
              <Form className="d-flex align-items-center justify-content-start gap-3 mb-2">
                <Form.Group>
                  <Form.Control
                    type="month"
                    name="payrollMonth"
                    value={state.payrollMonth}
                    max={maxMonth}
                    onChange={handelChange}
                    className="universal-input"
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Select
                    name="branchId"
                    value={state.branchId}
                    onChange={handelChange}
                    className="universal-input"
                    style={{ width: "180px" }}
                  >
                    <option value="">Select Branch</option>
                    {branch.map((row, idx) => {
                      return (
                        <option value={row.branchId} key={idx}>
                          {row.branch_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group>
                  <Form.Select
                    name="shiftId"
                    value={state.shiftId}
                    onChange={handelChange}
                    className="universal-input"
                    style={
                      { width: "180px" }
                    }
                  >
                    <option value="">Select Shift</option>
                    {shift.map((row, idx) => {
                      return (
                        <option value={row.shiftId} key={idx}>
                          {row.shiftName}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group>
                  <Form.Select
                    name="departmentId"
                    value={state.departmentId}
                    onChange={handelChange}
                    className="universal-input"
                    style={
                      { width: "180px" }
                    }
                  >
                    <option value="">Select Department</option>
                    {depart.map((row, idx) => {
                      return (
                        <option value={row.departmentId} key={idx}>
                          {row.department_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group>
                  {
                    (
                      state.payrollMonth != `${year_1}-${month_1}` ||
                      state.shiftId ||
                      state.departmentId ||
                      state.branchId) && <button type="button" className="clear" onClick={clearFilter}>
                      <MdClear /> Clear
                    </button>
                  }
                </Form.Group>
              </Form>
              {HasPermission("Run Payroll", "view") && (
                <button
                  className="universal-btn"
                  style={{ height: "40px" }}
                  onClick={navigateIt}
                >
                  Finalize Payroll
                </button>
              )}
            </div>
            {/* Cards--------------- */}
            <Row className="mt-3">
              <Col sm="4">
                <PayrollCard
                  title={"Total Payroll"}
                  subTitle={"Staff"}
                  subTitleValue={
                    Object.keys(summary).length > 0
                      ? summary.summary.actualStaffCount
                      : 0
                  }
                  amount={
                    Object.keys(summary).length > 0
                      ? summary.summary.OverAllNetSalary
                      : 0
                  }
                  dotClassName="inner-dot-primary"
                />
              </Col>

              <Col sm="4">
                <PayrollCard
                  title={"Paid"}
                  subTitle={"Staff"}
                  subTitleValue="-"
                  amount="-"
                  dotClassName="inner-dot-success"
                />
              </Col>

              <Col sm="4">
                <PayrollCard
                  title={"Pending"}
                  subTitle={"Staff"}
                  subTitleValue="-"
                  amount="-"
                  dotClassName="inner-dot-warning"
                />
              </Col>
            </Row>
            {/* Tables */}
            <Row className="mt-4">
              <Col sm="4">
                <h4 className="color-white mb-2">Earning Details</h4>
                <table style={{ width: "100%" }} className="payroll-sum-table">
                  <thead>
                    <tr>
                      <th>Earning Types</th>
                      <th>No of Staff</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Work Basis Payment</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Incentives</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Reimbursement</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Overtime Pay</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Other Earnings</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2}>Total</td>
                      <td>-</td>
                    </tr>
                  </tfoot>
                </table>
              </Col>

              <Col sm="8">
                <h4 className="color-white mb-2">
                  Statutory Compliance Details
                </h4>
                <table style={{ width: "100%" }} className="payroll-sum-table">
                  <thead>
                    <tr>
                      <th style={{ width: "220px" }}>
                        Statutory Compliance Details
                      </th>
                      <th style={{ width: "130px" }}>Employer Contribution</th>
                      <th style={{ width: "130px" }}>Employee Contribution</th>
                      <th style={{ width: "130px" }}>EDLI & Admin Charges</th>
                      <th style={{ width: "130px" }}>No. Of Staff</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Total Provident Fund</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Total Employees' State Insurance</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Total Labour Welfare Fund Tax</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Total Professional Tax</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Total Tax Deducted at Source</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={4}>Total Statutory</td>
                      <td>Employee</td>
                      <td>-</td>
                    </tr>
                  </tfoot>
                </table>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col sm="12">
                <h4 className="color-white mb-2">Loan Amount</h4>
                <table style={{ width: "100%" }} className="payroll-sum-table">
                  <thead>
                    <tr>
                      <th>Total Loan Amount</th>
                      <th style={{ width: "130px" }}>No of Staff</th>
                      <th style={{ width: "130px" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Given</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Received</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Pending Loan Amount</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2}>Total</td>
                      <td>-</td>
                    </tr>
                  </tfoot>
                </table>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default PayrollSummary;